import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const AdminAboutSection = () => {
  const { school_slug } = useParams();

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [aboutSectionDetails, setaboutSectionDetails] = useState(null);
  const [image, setImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const [form, setForm] = useState({
    heading: "",
    paragraph_1: "",
    paragraph_2: "",
    paragraph_3: "",
  });

  /* ---------------- FETCH DATA ---------------- */
  useEffect(() => {
    if (school_slug) {
      fetchAboutSection();
    }
  }, [school_slug]);

  const fetchAboutSection = async () => {
    try {
      const res = await axios.get(
        `${baseAPIUrl}admin/about_page/get_about_section/${school_slug}`,
        { withCredentials: true }
      );

      if (res.data.status === 1 && res.data.data) {
        const data = res.data.data;

        setForm({
          heading: data.heading || "",
          paragraph_1: data.paragraph_1 || "",
          paragraph_2: data.paragraph_2 || "",
          paragraph_3: data.paragraph_3 || "",
        });

        setaboutSectionDetails(res.data.data);

        if (data.about_section_image) {
          setPreviewImage(
            `${baseAPIUrl}assets/images/aboutsec/${data.about_section_image}?t=${Date.now()}`
          );
        }
      } else {
        setMessage("No data found for this school. You can add new content.");
      }
    } catch (err) {
      console.error(err);
      setMessage("Failed to load about section.");
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- Input Change ---------------- */
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  /* ---------------- File Change ---------------- */
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setImage(file);

    if (file) {
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  /* ---------------- Submit ---------------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("school_slug", school_slug);
      formData.append("heading", form.heading);
      formData.append("paragraph_1", form.paragraph_1);
      formData.append("paragraph_2", form.paragraph_2);
      formData.append("paragraph_3", form.paragraph_3);

      if (image) {
        formData.append("about_section_image", image);
      }

      const res = await axios.post(
        `${baseAPIUrl}admin/about_page/add_edit_page_section`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          withCredentials: true
        }
      );
      fetchAboutSection();
      scrollToTop();
      setMessage(res.data.msg);
    } catch (err) {
      console.error(err);
      scrollToTop();
      setMessage("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveImage = async () => {
      const confirmDelete = window.confirm(
          "Are you sure you want to delete this image? This action cannot be undone."
      );

      if (!confirmDelete) return;

      try {
          setLoading(true);
          const formData = new FormData();
          formData.append("school_slug", school_slug);
          const res = await axios.post(
              `${baseAPIUrl}admin/about_page/delete_about_section_image`,
              formData ,
              { withCredentials: true }
          );

          if (res.data.status === 1) {
              setPreviewImage("");
              setImage(null);
              fetchAboutSection();
              scrollToTop();
              setMessage(res.data.msg);
          } else {
              scrollToTop();
              setMessage(res.data.msg || "Failed to delete image");
          }
      } catch (err) {
          console.error(err);
          scrollToTop();
          setMessage("Failed to delete image.");
      } finally {
          setLoading(false);
          scrollToTop();
      }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0 text-dark">About Section</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/admin/dashboard">Dashboard</a>
                </li>
                <li className="breadcrumb-item active">About section</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h4>Edit About Section</h4>
                </div>

                <form onSubmit={handleSubmit} encType="multipart/form-data">
                  <div className="card-body">
                    {message && (
                      <p className="text-center text-info">{message}</p>
                    )}

                    <input type="hidden" value={school_slug} />

                    <div className="form-group">
                      <label>Heading</label>
                      <input
                        type="text"
                        name="heading"
                        className="form-control"
                        value={form.heading}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-group">
                      <label>Paragraph 1</label>
                      <textarea
                        name="paragraph_1"
                        rows="4"
                        className="form-control"
                        value={form.paragraph_1}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-group">
                      <label>Paragraph 2</label>
                      <textarea
                        name="paragraph_2"
                        rows="4"
                        className="form-control"
                        value={form.paragraph_2}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-group">
                      <label>Paragraph 3</label>
                      <textarea
                        name="paragraph_3"
                        rows="4"
                        className="form-control"
                        value={form.paragraph_3}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-group">
                      <label>About Image</label>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={handleFileChange}
                      />

                      {previewImage && (
                          <div style={{ marginTop: "10px" }}>
                              <img
                                  src={previewImage}
                                  alt="About section image Preview"
                                  style={{ maxWidth: "120px", display: "block", marginBottom: "8px" }}
                              />
                              {aboutSectionDetails?.about_section_image && (
                                <button
                                    type="button"
                                    className="btn btn-sm btn-danger"
                                    onClick={handleRemoveImage}
                                >
                                    Remove Image
                                </button>
                              )}
                          </div>
                      )}
                    </div>
                  </div>

                  <div className="card-footer">
                    <button className="btn btn-primary" disabled={loading}>
                      {loading ? "Saving..." : "Save"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdminAboutSection;
